// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3LIMH","rootCenter":"LoadMoreObserver_rootCenter__13j-Q","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__8e4Ml"};